class SettingConstants {

    public static readonly DEBOUNCE_INPUT_MS: number = 300;

}

export {SettingConstants};
